import React from 'react';
import './Cards.css';

function Cards() {
  return (
    <div className='cards'>
      
      <div className='cards__container'>
        <div></div>
      </div>
    </div>
  );
}

export default Cards;